import React from 'react'
import Mask from 'vanilla-masker'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const TextArea = (props) => {
  const {
    id,
    name,
    value,
    onChange,
    onKeyPress = () => {},
    onKeyDown = () => {},
    onKeyUp = () => {},
    onBlur,
    mask,
    label,
    disabled = false,
    minLength,
    maxLength,
    min,
    max,
    cols,
    rows,
    className = '',
    autoExpandable,
    onInput,
  } = props

  const handleChange = (event) => {
    /* istanbul ignore else */
    if (mask) {
      event.target.value = Mask.toPattern(event.target.value, mask)
    }

    onChange(event)
  }
  const handleBlur = (event) => {
    /* istanbul ignore else */
    if (onBlur) {
      onBlur(event)
    }
  }
  const handleKeyPress = (event) => {
    /* istanbul ignore else */
    if (onKeyPress) {
      onKeyPress(event)
    }
  }
  const handleKeyDown = (event) => {
    /* istanbul ignore else */
    if (onKeyDown) {
      onKeyDown(event)
    }
  }
  const handleKeyUp = (event) => {
    /* istanbul ignore else */
    if (onKeyUp) {
      onKeyUp(event)
    }
  }

  const handleInput = (event) => {
    if (autoExpandable) {
      const field = event.target
      field.style.height = 'auto'

      const computed = window.getComputedStyle(field)
      const height =
        parseInt(computed.getPropertyValue('border-top-width'), 10) +
        field.scrollHeight +
        parseInt(computed.getPropertyValue('border-top-width'), 10)

      field.style.height = `${height}px`
    }

    if (onInput) {
      onInput(event)
    }
  }

  const inputClass = classNames('textarea')

  return (
    <div>
      <textarea
        name={name}
        id={id}
        className={`${inputClass} ${className}`}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyPress={handleKeyPress}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        disabled={disabled}
        minLength={minLength}
        maxLength={maxLength}
        min={min}
        max={max}
        cols={cols}
        rows={rows}
        onInput={handleInput}
      />
      {label && (
        <label htmlFor={id} className='label'>
          {label}
        </label>
      )}
    </div>
  )
}

TextArea.propTypes = {
  id: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onBlur: PropTypes.func,
  mask: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  cols: PropTypes.number,
  rows: PropTypes.number,
  className: PropTypes.string,
  autoExpandable: PropTypes.bool,
  onInput: PropTypes.func,
}

export default TextArea
